
export const languagesList = ["English", "Hindi"];
export const identityList = ["Male", "Female", " Non-conforming"];